
let config = {};

switch (process.env.NODE_ENV){
	case 'production':{
		config.stripe = {
			publicKey:'pk_live_7VcifpgfjXcn6bALkmD6s2dF'
		};
		config.host = {
			app:'https://scoutred.com',
			api:'https://scoutred.com'
		};
		config.mapStyles = {
			satellite: 'https://styles.scoutred.com/v2/scoutred-satellite.json',
			vector: 'https://styles.scoutred.com/v2/scoutred.json'
		};
		config.routerBase = '/maps/';
		config.googleAnalytics = {
			trackingId: 'G-P83889C01L'
		};
		config.mapbox = {
			accessToken: 'pk.eyJ1IjoiYXJvbGVrIiwiYSI6ImNtdDR6bTZwdjB6aWsyd3E3MjhqaWg3aGUifQ.xCJpYO2V66oTeDRiwl4pGw'
		};
		break;
	};
	case 'stage':{
		config.stripe = {
			publicKey:'pk_test_BJsWwz3dCXP1RPqBgTzHG0me'
		};
		config.host = {
			app:'https://dev.scoutred.com',
			api:'https://dev.scoutred.com'
		};
		config.mapStyles = {
			satellite: 'https://styles-dev.scoutred.com/v2/scoutred-satellite.json',
			vector: 'https://styles-dev.scoutred.com/v2/scoutred.json'
		};
		config.googleAnalytics = {
			trackingId: 'G-JECHCVPRTB'
		};
		config.routerBase = '/maps/';
		config.mapbox = {
			accessToken: 'pk.eyJ1IjoiYXJvbGVrIiwiYSI6ImNtdDR6bTZwdjB6aWsyd3E3MjhqaWg3aGUifQ.xCJpYO2V66oTeDRiwl4pGw'
		};
		break;
	};
	case 'dev-remote':{
		config.stripe = {
			publicKey:'pk_test_BJsWwz3dCXP1RPqBgTzHG0me'
		};
		config.host = {
			app:'https://dev.scoutred.com',
			api:'https://dev.scoutred.com'
		};
		config.mapStyles = {
			satellite: 'https://styles-dev.scoutred.com/v2/scoutred-satellite.json',
			//satellite: 'http://localhost:9997/carto/styles/v2/scoutred-satellite.json',
			vector: 'https://styles-dev.scoutred.com/v2/scoutred.json'
			//vector: 'http://localhost:9997/carto/styles/v2/scoutred.json'
		};
		config.googleAnalytics = {
			trackingId: 'G-JECHCVPRTB'
		};
		config.routerBase = '/maps/';
		config.mapbox = {
			accessToken: 'pk.eyJ1IjoiYXJvbGVrIiwiYSI6ImNtdDR6bTZwdjB6aWsyd3E3MjhqaWg3aGUifQ.xCJpYO2V66oTeDRiwl4pGw'
		};
		break;
	};
	default:{ // dev local
		config.stripe = {
			publicKey:'pk_test_BJsWwz3dCXP1RPqBgTzHG0me'
		};
		config.host = {
			app:'https://dev.scoutred.com',
			api:'http://localhost:8080'
		};
		config.mapStyles = {
			satellite: 'https://styles-dev.scoutred.com/v2/scoutred-satellite.json',
			vector: 'https://styles-dev.scoutred.com/v2/scoutred.json'
		};
		config.googleAnalytics = {
			trackingId: 'G-JECHCVPRTB'
		};
		config.routerBase = '/maps/';
		config.mapbox = {
			accessToken: 'pk.eyJ1IjoiYXJvbGVrIiwiYSI6ImNtdDR6bTZwdjB6aWsyd3E3MjhqaWg3aGUifQ.xCJpYO2V66oTeDRiwl4pGw'
		};
		break;
	}
}

export default config;


// WEBPACK FOOTER //
// ./src/config/index.js